export default __webpack_public_path__ + "static/media/main-characters-padded-lg-1x.cd986d23.jpg";